import {
    STOCK_TAKING_CAR_MANAGEMENT_SALES_TYPE_CATALOG_BEGIN,
  } from '../constants';
  
  export function getSalesTypeCatalogs() {
    return (dispatch) => {
      dispatch({
        type: STOCK_TAKING_CAR_MANAGEMENT_SALES_TYPE_CATALOG_BEGIN,
      })
    }
  }